import React, { useRef, useState } from "react";
import { Button, IconButton, VerticalDivider, useIsOverflowing, } from "@sscs/ui";
import { CaretLeftIcon as ArrowLeft, CaretRightIcon as ArrowRight, } from "@sscs/ui/icons";
import { getClassName } from "@sscs/utils";
import { getNameFromSignatureProperties } from "../../../../utils";
import { getSignatureIdentity } from "../utils";
import styles from "./selectorTabs.module.scss";
const SelectorTabs = ({ signatureState, signatures, dangling_certificates, certificates, onSelectSignature, onSelectDanglingCertificate, }) => {
    const [scrolledToLeft, setScrolledToLeft] = useState(true);
    const [scrolledToRight, setScrolledToRight] = useState(false);
    const containerRef = useRef(null);
    const isOverflowing = useIsOverflowing(containerRef, "x");
    const scrollBy = 216; // 200px for button width + 16px for flex gap
    const handleScroll = async (initialScrollBy) => {
        if (!containerRef.current) {
            return;
        }
        const waitForScroll = (element) => {
            return new Promise((resolve) => {
                let targetScrollBy = 0;
                if (initialScrollBy > 0) {
                    targetScrollBy = Math.min(element.scrollWidth - element.clientWidth - element.scrollLeft, initialScrollBy);
                }
                else {
                    targetScrollBy = Math.max(-element.scrollLeft, initialScrollBy);
                }
                if (targetScrollBy === 0) {
                    resolve();
                }
                const targetScrollLeft = element.scrollLeft + targetScrollBy;
                const onScroll = () => {
                    const reachedScrollWidthStart = element.scrollLeft === 0;
                    const reachedScrollWidthEnd = element.scrollLeft === element.scrollWidth - element.clientWidth;
                    const reachedTargetScroll = element.scrollLeft === targetScrollLeft;
                    if (reachedScrollWidthStart ||
                        reachedScrollWidthEnd ||
                        reachedTargetScroll) {
                        element.removeEventListener("scroll", onScroll);
                        resolve();
                    }
                };
                element.addEventListener("scroll", onScroll);
                element.scrollBy({ left: initialScrollBy, behavior: "smooth" });
            });
        };
        await waitForScroll(containerRef.current);
        setScrolledToLeft(containerRef.current.scrollLeft === 0);
        setScrolledToRight(containerRef.current.scrollLeft + containerRef.current.clientWidth >=
            containerRef.current.scrollWidth);
    };
    return (React.createElement("div", { className: getClassName(styles.signatures, {
            [styles["dangling-certificate"]]: signatureState.danglingCertificateIndex !== undefined,
        }) },
        React.createElement("div", { ref: containerRef, className: styles.scroller },
            isOverflowing && !scrolledToLeft && (React.createElement("div", { className: styles["scroll-left"] },
                React.createElement(IconButton, { "aria-label": "scroll-left", className: styles["scroll-button"], onClick: () => handleScroll(-scrollBy) },
                    React.createElement(ArrowLeft, null)))),
            signatures.map((signature, index) => (React.createElement(Button, { key: index, id: `signature-${index.toString()}`, disabled: signatureState.signatureIndex === index, color: "secondary", className: getClassName(styles["signature-button"], {
                    [styles["selected-signature"]]: signatureState.signatureIndex === index,
                }), onClick: () => onSelectSignature(index, signatures[index].signature.cert_chain[0][1]) },
                React.createElement("div", { className: styles["signature-label"] }, "Signature"),
                React.createElement("div", { className: styles.subject, title: getSignatureIdentity(signature, certificates) }, getSignatureIdentity(signature, certificates))))),
            dangling_certificates.length > 0 ? (React.createElement(React.Fragment, null,
                signatures.length > 0 && React.createElement(VerticalDivider, null),
                dangling_certificates.map((certificateId, index) => (React.createElement(Button, { key: index, id: `extra-cert-${index.toString()}`, disabled: signatureState.danglingCertificateIndex === index, color: "secondary", className: getClassName(styles["signature-button"], {
                        [styles["selected-signature"]]: signatureState.danglingCertificateIndex === index,
                    }), onClick: () => onSelectDanglingCertificate(index, dangling_certificates[index]) },
                    React.createElement("div", { className: styles["signature-label"] }, "Extra certificate"),
                    React.createElement("div", { className: styles.subject, title: getNameFromSignatureProperties(certificates[certificateId].subject) }, getNameFromSignatureProperties(certificates[certificateId].subject))))))) : null,
            isOverflowing && !scrolledToRight && (React.createElement("div", { className: styles["scroll-right"] },
                React.createElement(IconButton, { "aria-label": "scroll-right", className: styles["scroll-button"], onClick: () => handleScroll(scrollBy) },
                    React.createElement(ArrowRight, null)))))));
};
export default SelectorTabs;
//# sourceMappingURL=SelectorTabs.js.map